export const STATIC_BASE_ROUTE = '/static'
export const USER_BASE_ROUTE = '/user'

export const ROUTERS = {
  INIT: '/',
  CREATE_PROFILE: '/create-profile',
  CREATE_PROFILE_SUCCESS: '/create-profile-success',
  ADD_RESPONSIBLE_PERSON: '/add-responsible-person',
  FAILED_SCREEN: '/fail-screen',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_COMPLETED: '/reset-password-completed',
  SET_NEW_PASSWORD: '/set-new-password',
  SET_NEW_PASSWORD_SUCCESS: '/set-new-password-success',
  SET_NEW_PASSWORD_LINK_EXPIRED: '/set-new-password-link-expired',
  PROFILE_DELETED: '/profile-deleted-success',
  USER: {
    SCORE: `${USER_BASE_ROUTE}/score-card`,
    PROFILE: `${USER_BASE_ROUTE}/profile`,
    MEMBERS: `${USER_BASE_ROUTE}/members`,
    CREATE_AND_EDIT_MEMBER: `${USER_BASE_ROUTE}/create-edit-member`,
    MEMBER_TO_USER: `${USER_BASE_ROUTE}/invite-member`,
    QR_CODE: `${USER_BASE_ROUTE}/qr-code`,
  },
  STATIC: {
    PRIVACY_POLICY: `${STATIC_BASE_ROUTE}/privacy-policy`,
    DISCLAIMER: `${STATIC_BASE_ROUTE}/disclaimer`,
    RULES: `${STATIC_BASE_ROUTE}/rules`
  },
};
